import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Container from 'common/Container';
import {
  Hero,
  CampaignContent,
  ExpedientesSection,
  Metrics,
  Products,
  ValueAdd,
  WinWin,
  InvestmentSummary,
  AreYouReady,
} from './components';

const LandingMediaKitDanimar = ({ themeMode = 'light' }) => {
  return (
    <Box>
      <Container>
        <Hero themeMode={themeMode} />
      </Container>
      <Container>
        <CampaignContent />
      </Container>
      <Container>
        <ExpedientesSection />
      </Container>
      <Container>
        <Metrics />
      </Container>
      <Container>
        <Products />
      </Container>
      <Container>
        <ValueAdd />
      </Container>
      <Container>
        <WinWin />
      </Container>
      <Container>
        <InvestmentSummary />
      </Container>
      <Container>
        <AreYouReady />
      </Container>
    </Box>
  );
};

LandingMediaKitDanimar.propTypes = {
  themeMode: PropTypes.string,
};

export default LandingMediaKitDanimar;

